'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import {RelativeContainer} from '../ui/RelativeContainer.js';
import {ContentViewSession} from '../viewer/ContentView.js';
import {BoxDisposition, BoxContentControl} from '../content/BoxContent.js';

const privateMap = util.createPrivateMapper();

class DragControl {
  constructor(boxControl){
    this.boxControl = boxControl;
    this.basePosition = new Point2D();
    this.base = new Point2D();
    this.target = null;
  }
  start(ev){
    ev.preventDefault();
    if (!this.view || !this.control) {
      return false;
    }
    const pt = this.control.disposition.offset;
    this.basePosition.x = pt.x;
    this.basePosition.y = pt.y;
    this.base = new Point2D(ev.clientX, ev.clientY);
    return true;
  }
  drag(ev){
    if (!this.view || !this.control) {
      return;
    }
    const pt = new Point2D(ev.clientX, ev.clientY);
    const dpt = pt.sub(this.base);
    const z = this.control.disposition.zoom / this.boxControl.disposition.zoom;
    this.control.move(this.basePosition.sub(dpt.mul(z)));
    this.view.requestRender();
  }
  end(ev){
    
  }
}

export class ImageOutlineView extends UiComponent {
  constructor(domEl, argOptions){
    super(domEl);
    const pv = privateMap(this);
    const _self = this;
    const options = argOptions ? argOptions : {};

    pv.boxControl = new BoxContentControl();
    pv.control = {
      box: pv.boxControl
    }
    pv.view = null;
    pv.renderTimeout = false;
    pv.size = new Point2D();

    pv.canvas = domUtil.createElement('canvas');
    pv.context2d = pv.canvas.getContext('2d');
    domUtil.asAbsoluteFit(pv.canvas);
    domUtil.noBoundary(pv.canvas);
    domEl.appendChild(pv.canvas);

    pv.viewRegion = options.viewRegionEl ? options.viewRegionEl : domUtil.createElement('div');
    domUtil.asAbsolute(pv.viewRegion);
    domEl.appendChild(pv.viewRegion);
    domUtil.setStyle(pv.viewRegion, 'display', 'none');

    pv.render = () => {
      // pv.renderRequestId = false;
      // if (!pv.renderer) {
      //   return;
      // }
      // // clear canvas
      // pv.canvas.width = pv.canvas.width;

      // renderer.render(renderCanvas, boxControl.disposition, requestRender);

      pv.renderTimeout = false;
      pv.canvas.width = pv.canvas.width
      // domUtil.canvasResize(pv.canvas, pv.relativeContainer.size);
      if (pv.view && pv.view.renderer && pv.view.resource) {
        pv.view.renderer.render(this, pv.view.resource, pv.control, pv.session);
      }
    }

    pv.dispositionchangedHandler = (ev) => {
      if (!pv.view){
        return;
      }
      const viewRegion = pv.viewRegion;
      const disposition = pv.view.control.box.disposition;
      const vz = pv.boxControl.disposition.zoom;
      const ratio = vz / disposition.zoom;
      const sz = pv.view.size.mul(ratio);
      const borderSz = domUtil.getOffsetSize(viewRegion).sub(domUtil.getSize(viewRegion));
      domUtil.setPosition(viewRegion, pv.size.div(2).sub(disposition.offset.mul(ratio)).sub(sz.div(2)).sub(borderSz.div(2)));
      domUtil.setSize(viewRegion, sz.add(borderSz));
      domUtil.rotate(viewRegion, -disposition.angle);
    };

    pv.dragControl = new DragControl(pv.boxControl);
    const mousemoveHandler = (ev) => {
      pv.dragControl.drag(ev);
    }
    const mouseupHandler = (ev) => {
      domUtil.removeEventListener(window, 'mousemove', mousemoveHandler);
      domUtil.removeEventListener(window, 'mouseup', mouseupHandler);
      pv.dragControl.end(ev);
    }
    const dragHandler = (ev) => {
      if (pv.dragControl.start(ev) == false) {
        return;
      }
      domUtil.addEventListener(window, 'mousemove', mousemoveHandler);
      domUtil.addEventListener(window, 'mouseup', mouseupHandler);
    }
    const playHandler = (ev) => {
      this.requestRender();
    }
    pv.contentChangeHandler = (ev) => {
      pv.dragControl.control = null;
      if (pv.session) {
        pv.session.destroy();
      }
      if (pv.control.playback) {
        pv.control.playback.removeEventListener('play', playHandler);
      }
      pv.control.playback = null;
      if (pv.view && pv.view.resource) {
        pv.session = new ContentViewSession();
        this.active = true;
        domUtil.setStyle(pv.viewRegion, 'display', '');
        pv.dragControl.view = pv.view;
        pv.dragControl.control = pv.view.control.box;
        pv.boxControl.boxSize = pv.view.resource.size;
        pv.boxControl.fit();
        if (pv.view.control && pv.view.control.playback) {
          pv.view.control.playback.addEventListener('play', playHandler);
          pv.control.playback = pv.view.control.playback;
        }
        domUtil.addEventListener(pv.viewRegion, 'mousedown', dragHandler);
      } else {
        this.active = false;
        domUtil.setStyle(pv.viewRegion, 'display', 'none');
        domUtil.removeEventListener(pv.viewRegion, 'mousedown', dragHandler);
      }
      this.requestRender();
    }

    this.active = false;
    this.applySize();
  }

  get context2d(){
    return privateMap(this).context2d;
  }

  get size(){
    return privateMap(this).size.clone();
  }

  get center(){
    return privateMap(this).size.div(2);
  }

  requestRender(){
    const pv = privateMap(this);
    if (pv.renderTimeout) {
      return;
    }
    pv.renderTimeout = requestAnimationFrame(pv.render);
  }

  link(view){
    this.unlink();
    const pv = privateMap(this);
    pv.view = view;
    if (pv.view) {
      domUtil.addEventListener(pv.view.eventLayer, 'ui.contentchange', pv.contentChangeHandler);
      domUtil.addEventListener(pv.view.eventLayer, 'ui.contentrender', pv.dispositionchangedHandler);
    }
    this.requestRender();
  }

  unlink(){
    const pv = privateMap(this);
    if (!pv.view) {
      return;
    }
    domUtil.removeEventListener(pv.view.eventLayer, 'ui.contentchange', pv.contentChangeHandler);
    domUtil.removeEventListener(pv.view.eventLayer, 'ui.contentrender', pv.dispositionchangedHandler);
    domUtil.setStyle(pv.viewRegion, 'display', 'none');
    this.active = false;
    this.requestRender();
  }

  applySize(){
    const pv = privateMap(this);
    pv.size = domUtil.getSize(this.domEl);
    pv.boxControl.viewSize = pv.size;
    pv.boxControl.fit();
    domUtil.canvasResize(pv.canvas, pv.size);
    pv.dispositionchangedHandler()
    this.requestRender();
  }
}
